<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "ToggleProductMatches" });
import { InputToggle } from "../../../../selects/index.js";
export let isChecked = false;
export let isDisabled = false;
export let isRequired = false;
</script>

<InputToggle
    bind:isChecked
    name = 'products.showOnlyMatches'
    label = 'Show only matching products'
    color = 'quaternary'
    size = 'lg'
    { isDisabled }
    { isRequired }
/>